<template>
  <div class="bordered-content-row dark">
    <div class="row">
        <div class="col-lg-3 col-md-12">
          <h2 class="title ">{{ province }}</h2>
        </div>

        <template v-for="(hotel, index) in hotels">

          <HotelTile :hotel="hotel" :key="`${hotel.id}}`" :has-offset="index >= 1 && index % 3 == 0" />
        </template>
    </div>
  </div>
</template>

<script>
import HotelTile from './hotel-tile'
export default {
  name: 'ProvinceListing',
  components: { HotelTile },
  props: {
    province: {
      type: String,
      required: true
    },
    hotels: {
      type: Array,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/province-listing.vue